import Request from '@/utils/request'

// midR充值
export function repurchaseMidRActCfg() {
  return Request({
    url: '/api/v2/app/shop/activity/13/cfg',
    method: 'get',
    envelope: false,
  })
}

// midR充值
export function repurchaseMidRActClaim(rewardId) {
  return Request({
    url: `/api/v2/app/shop/activity/13/reward/${rewardId}`,
    method: 'put',
    envelope: false,
  })
}

// topR充值
export function repurchaseTopRActCfg() {
  return Request({
    url: '/api/v2/app/shop/activity/14/cfg',
    method: 'get',
    envelope: false,
  })
}

// topR充值
export function repurchaseTopRActClaim(rewardId) {
  return Request({
    url: `/api/v2/app/shop/activity/14/reward/${rewardId}`,
    method: 'put',
    envelope: false,
  })
}
